import { Sigma, Package } from "lucide-react";
import type { LucideIcon } from "lucide-react";

// Built-in Flow methods and pre-installed Notebook libraries (from the product briefs).
const METHODS = [
  "Summary statistics", "t-test", "Mann-Whitney U", "ANOVA", "Kruskal-Wallis", "Chi-squared", "Fisher's exact", "Pearson", "Spearman", "Kendall",
  "Linear regression", "Logistic regression", "Poisson regression", "Multinomial regression", "Ordinal regression", "Kaplan–Meier",
  "ROC curves", "Q–Q plots", "Outlier detection", "EDA profiling", "Group comparisons", "Effect sizes",
];
const LIBRARIES = [
  "pandas", "polars", "NumPy", "SciPy", "statsmodels", "scikit-learn", "XGBoost", "LightGBM", "lifelines", "matplotlib",
  "seaborn", "Plotly", "tidyverse", "data.table", "survival", "broom", "gt", "patchwork", "+ any PyPI or CRAN package",
];

function MarqueeRow({ items, icon: Icon, reverse }: { items: string[]; icon: LucideIcon; reverse?: boolean }) {
  return (
    <div className="flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
      <div
        className="flex shrink-0 gap-3 pr-3 animate-[marquee_60s_linear_infinite] motion-reduce:animate-none hover:[animation-play-state:paused]"
        style={reverse ? { animationDirection: "reverse" } : undefined}
      >
        {[...items, ...items].map((item, i) => (
          <span
            key={i} aria-hidden={i >= items.length}
            className={`inline-flex shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm ${item.startsWith("+") ? "border-[#1E4FD8]/40 dark:border-[#4A90D9]/40 text-[#1E4FD8] dark:text-[#4A90D9] font-medium" : "border-[#0A0A0F]/10 dark:border-white/10 bg-white dark:bg-[#0D0D10] text-[#0A0A0F] dark:text-white"}`}
          >
            <Icon size={14} className="text-[#1E4FD8] dark:text-[#4A90D9]" />{item}
          </span>
        ))}
      </div>
    </div>
  );
}

export function MethodsMarquee() {
  return (
    <div className="space-y-3" aria-label="Built-in statistical methods and pre-installed libraries">
      <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-[#5C5C66] dark:text-[#9A9A9A] mb-5">
        Built-in methods · pre-installed libraries · and room for whatever you need
      </p>
      <MarqueeRow items={METHODS} icon={Sigma} />
      <MarqueeRow items={LIBRARIES} icon={Package} reverse />
    </div>
  );
}
